export default {
    enable: Boolean, 
    icon: String, 
    imageUrl: String, 
    spriteCssClass: String, 

    // Events
    click: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/ButtonProps.js